import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../_models/api-response.model';
import { UserList } from '../../_models/user.model';
import { TopAgent } from '../../_models/agent.model';

export interface DashboardStats {
  usersCount: number;
  agentsCount: number;
  reservationsCount: number;
  latestUsers: UserList[];
  topAgentsCurrentMonth: TopAgent[]
}

@Injectable({
  providedIn: 'root'
})
export class AdminDashboardService {
  private apiUrl = `${environment.apiUrl}/admin/dashboard`;
 
  constructor(private http: HttpClient) {}

  getDashboardStats(): Observable<ApiResponse<DashboardStats>> {
    return this.http.get<ApiResponse<DashboardStats>>(`${this.apiUrl}/stats`);
  }
}